import IconEdit from '../../../../components/icons/icon-edit/icon-edit';
import { ButtonIcon } from '../../../../components/inputs/button-icon/button-icon';

interface EditUserButtonProps {
    children?: React.ReactNode;
    onClick: () => void;
    disabled?: boolean;
}

const EditUserButton: React.FC<EditUserButtonProps> = ({ onClick, disabled }) => {
    return (
        <ButtonIcon Component={IconEdit} onClick={onClick} disabled={disabled}/>
    );
};

export default EditUserButton;
